import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components/index";
import GoogleMapReact from "google-map-react";
import API from "@beardeddevops/react.api";
import PinDrop from "@material-ui/icons/PinDrop";
import {Call_Geocode_API, parseLatLngString} from "../../constants/Utilities";
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";
/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */

const PinLocation = ({text}) => {
	return (
		<div style={{textAlign: 'center', width: '40px', fontSize: '20px'}}>
			<PinDrop fontSize={'small'} color={'primary'}/><br/>
			<span style={{fontSize: '10px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>{text}</span>
		</div>
	);
};

const CustomerPinLocation = ({text}) => {
	return (
		<div style={{textAlign: 'center', width: '40px', fontSize: '20px'}}>
			<PinDrop fontSize={'small'} color={'error'}/><br/>
			<span style={{fontSize: '10px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>{text}</span>
		</div>
	);
};

export default class ScheduleMapRouting extends Framework.Components.Collection {
	constructor(props) {
		super(props, Types.Users._name);
		this.request = 'GET_FIELD_ENGINEERS_ROUTING';

		this.state.items = [];
		this.state.key = 0;

		this.state.name = '';
		this.state.region = null;

		this.state.customerLat = null;
		this.state.customerLong = null;

		this.state.center = null;
		this.state.defaultCenter = {
			lat: 33.44838,
			lng: -112.07404
		};
		let address = JSON.parse(localStorage.getItem('findFEAddress'))
		if (address) {
			localStorage.removeItem('findFEAddress')
			this.state.findFEAddress = address;
			if (address.latitude && address.longitude) {
				this.state.defaultCenter = {
					lat: parseFloat(address.latitude),
					lng: parseFloat(address.longitude)
				};
			}

		}
	}

	

	apiIsLoaded = (map, maps) => {
		this.state.map = map;
		this.state.maps = maps;
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevState.region !== this.state.region || prevState.customerLat !== this.state.customerLat || prevState.customerLong !== this.state.customerLong) {
			this.getUsers().then(this.forceUpdate());
			// setInterval(this.forceUpdate(), 3000);
			setTimeout(() => {
				this.forceUpdate()
			}, 1500);
		}
	}

	getUsers = async () => {
		//call users here and get the locations of FEs and drop pins
		let pkeyModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		pkeyModel.filter = {
			'filterRegion': this.state.region
		}
		let field_engineers = await pkeyModel.submit(null, 'GET_FIELD_ENGINEERS_ROUTING');

		if (this.state.map) {
			const latLng = new this.state.maps.LatLng(this.state.customerLat ?? functioning.lat, this.state.customerLong ?? functioning.long); // Makes a latlng
			this.state.map.panTo(latLng);
		}

		field_engineers.items.map(async (item, i) => {
			//if the FEs lat/long are null then call geocode and save it, else use what we have
			if (field_engineers.items[i]['latitude'] === null || field_engineers.items[i]['longitude'] === null) {
				const parsed = parseLatLngString(item.address);
				field_engineers.items[i]['newLatLong'] = parsed
					|| await Call_Geocode_API(item.address, {suppressToast: true});

				if (field_engineers.items[i]['newLatLong']?.latitude != null
					&& field_engineers.items[i]['newLatLong']?.longitude != null) {
					let usersModel = new API.BuildClass(Types.Users._name, API.RequestType.UPDATE);
					usersModel.object.user = field_engineers.items[i]['pkey'];
					usersModel.object.latitude = field_engineers.items[i]['newLatLong']['latitude'];
					usersModel.object.longitude = field_engineers.items[i]['newLatLong']['longitude'];
					await usersModel.submit(null, 'POST_COORDS', true);
				}
			} else {
				field_engineers.items[i]['newLatLong'] = {
					latitude: field_engineers.items[i]['latitude'],
					longitude: field_engineers.items[i]['longitude'],
				}
			}
		});

		this.setState({
			defaultCenter: {
				lat: this.state.customerLat ?? field_engineers.lat,
				lng: this.state.customerLong ?? field_engineers.long
			},
			items: field_engineers.items
		});
	}

	updateRegion = (region, name) => {
		this.setState({region, name})
	}

	updateGivenAddress = (lat, long) => {
		this.setState({customerLat: lat, customerLong: long,});
	}

	render() {
		let zoom = 9;
		let extras = {};

		let object = this.state;

		if (object.center) {
			extras.center = object.center;
		}

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-4"}>
							<Objects.CustomerLocation
								id={object.location?.pkey}
								parent={object.customer?.pkey}
								history={this.props.history}
								hasModal={true}
								updateRegion={this.updateRegion}
								updateGivenAddress={this.updateGivenAddress}
								address={this.state.findFEAddress}
							/>
						</div>
						<div className={"col-8"}>
							<div style={{height: '74vh', width: '100%'}}>

								<GoogleMapReact
									bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
									defaultCenter={object.defaultCenter}
									defaultZoom={zoom}
									yesIWantToUseGoogleMapApiInternals
									onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
									ref={(ref) => {
										this.mapRef = ref;
									}}
									{...extras}
								>
									{/*customer pin*/}
									{object.customerLat && object.customerLong &&
										<CustomerPinLocation
											zoom={zoom}
											lat={object.customerLat}
											lng={object.customerLong}
											text={"Customer"}
										/>
									}

									{object.items && object.items.map(
										(item, i) => {
											console.log(item.newLatLong, "item")
											if (!item.newLatLong) {
												console.log("returning null in map")
												return null;
											}
											return (
												<PinLocation
													key={i}
													zoom={zoom}
													lat={item.newLatLong.latitude}
													lng={item.newLatLong.longitude}
													text={item.name_first + ' ' + item.name_last}
												/>
											)
										}
									)}
								</GoogleMapReact>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={object.loading}/>
			</div>
		)
	}
}
